import dynamic from 'next/dynamic'
import { AuthModalProps } from '@containers/competitions/auth-modal'
const AuthModal = dynamic(() => import('@containers/competitions/auth-modal'))

const AuthModalDynamic = (props: AuthModalProps) => (
  <>{props.isOpen && <AuthModal {...props} />}</>
)

export default AuthModalDynamic
